import React from 'react';
import PropTypes from 'prop-types';
import {stackupToolCompanyStacksUsing} from '../../../../../data/stackups/queries';
import {ListContainer} from '../../../../../shared/library/cards/card';
import ServiceTile, {SMALL} from '../../../../../shared/library/tiles/service';
import ListCard, {RowContainer, RowLabel} from '../../../../../shared/library/cards/list-card';

const Row = ({item: {canonicalUrl, owner}}) => {
  const {name, imageUrl, thumbUrl} = owner || {};
  const image = thumbUrl ? thumbUrl : imageUrl;
  return (
    owner && (
      <RowContainer href={canonicalUrl}>
        <ServiceTile size={SMALL} imageUrl={image} useAnchor={false} name={name} />
        <RowLabel>{name}</RowLabel>
      </RowContainer>
    )
  );
};

Row.propTypes = {
  item: PropTypes.object
};

const CompaniesUsingCard = ({slug, items, title, disableScroll, limitItems}) => {
  return (
    <ListContainer>
      <ListCard
        disableScroll={disableScroll}
        title={title}
        itemsData={items}
        variables={{slug}}
        query={stackupToolCompanyStacksUsing}
        normalizeData={data => data.tool.companyStacksUsing}
        placeholder={'No companies found'}
        Row={Row}
        limitItems={limitItems}
      />
    </ListContainer>
  );
};

CompaniesUsingCard.propTypes = {
  slug: PropTypes.string,
  items: PropTypes.object,
  title: PropTypes.string,
  disableScroll: PropTypes.bool,
  limitItems: PropTypes.number
};

export default CompaniesUsingCard;
